const Validate = {
  isValid: (filed, value) => {
    switch (filed) {
      case 'mobile': // 手机号码校验
      {
        let reg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/
        if (reg.test(value)) {
          return true
        } else {
          return false
        }
      }
      case 'code': // 手机验证码 6位数纯数字
      {
        let reg = /^\d{6}$/
        if (reg.test(value)) {
          return true
        } else {
          return false
        }
      }
      case 'link': // 超链接 6位数纯数字
      {
        let reg = /^http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?/
        if (reg.test(value)) {
          return true
        } else {
          return false
        }
      }
    }
  }
}

export default Validate



// WEBPACK FOOTER //
// ./src/utils/validate.js